import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  ${props => props.addBackground && `background-color: ${props.theme.color.monochrome.white};`}
`
const Image = styled.img`
  flex: 0 0 auto;
  object-fit: contain;
  position: relative;
  visibility: visible;
  height: 100%;
  width: 100%;
  opacity: 30%;
  top: 0px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  -webkit-user-drag: none;
`

export { Container, Image }
